module.exports = __webpack_public_path__ + "staticVue/img/3.4ef0a8cd.png";